@let f = filter();
<label [for]="f.name">{{ f.name }}:</label>
<select [id]="f.name" (change)="selectionChange($event)" [value]="f.selected">
  @for (val of f.values; track val) {
    <option [value]="val">{{ val }}</option>
  }
</select>
